import React, { useState, useEffect } from 'react';

const CONSENT_KEY = 'admob_consent';

export default function ConsentBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);
    if (!saved) setVisible(true);
  }, []);

  function handleAccept(type) {
    localStorage.setItem(CONSENT_KEY, type); // 'personalized' | 'basic'
    setVisible(false);
  }

  if (!visible) return null;

  return (
    <div style={{
      position: 'fixed',
      bottom: 0,
      left: 0,
      right: 0,
      zIndex: 9999,
      background: '#14141f',
      border: '1px solid rgba(240,180,41,0.25)',
      borderBottom: 'none',
      borderRadius: '16px 16px 0 0',
      padding: '20px 20px 32px',
      maxWidth: 480,
      margin: '0 auto',
      boxShadow: '0 -8px 30px rgba(0,0,0,0.5)',
      animation: 'slideUp 0.3s ease',
    }}>
      <style>{`
        @keyframes slideUp { from { transform: translateY(100%); } to { transform: translateY(0); } }
      `}</style>

      {/* Handle */}
      <div style={{ width: 36, height: 4, background: 'rgba(255,255,255,0.15)', borderRadius: 2, margin: '0 auto 16px' }} />

      <div style={{ fontFamily: "'Oswald',sans-serif", fontSize: 15, fontWeight: 600, letterSpacing: 1, color: '#F5F5F0', marginBottom: 8 }}>
        🔔 ANUNCIOS EN PITAZO MUNDIAL
      </div>

      <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 13, color: '#aaa', lineHeight: 1.7, marginBottom: 20 }}>
        Usamos anuncios para mantener la app gratuita. ¿Aceptas anuncios personalizados? Puedes elegir solo anuncios básicos si prefieres.
      </p>

      <div style={{ display: 'flex', gap: 10 }}>
        <button
          onClick={() => handleAccept('personalized')}
          style={{
            flex: 1,
            padding: '13px',
            background: 'linear-gradient(90deg, #F0B429, #C9820A)',
            border: 'none',
            borderRadius: 12,
            fontFamily: "'Oswald',sans-serif",
            fontSize: 14,
            fontWeight: 700,
            letterSpacing: 1,
            color: '#080810',
            cursor: 'pointer',
          }}>
          ✅ SÍ, ACEPTO
        </button>

        <button
          onClick={() => handleAccept('basic')}
          style={{
            flex: 1,
            padding: '13px',
            background: 'transparent',
            border: '1px solid rgba(255,255,255,0.12)',
            borderRadius: 12,
            fontFamily: "'Oswald',sans-serif",
            fontSize: 13,
            fontWeight: 600,
            letterSpacing: 1,
            color: '#6B6B7B',
            cursor: 'pointer',
          }}>
          SOLO BÁSICOS
        </button>
      </div>

      <p style={{ fontFamily: "'Inter',sans-serif", fontSize: 10, color: '#333', textAlign: 'center', marginTop: 12, lineHeight: 1.6 }}>
        Los anuncios no interfieren con predicciones ni navegación.{' '}
        <a href="https://pitazomundial.com/privacidad.html" target="_blank" rel="noreferrer"
          style={{ color: '#444', textDecoration: 'underline' }}>
          Política de Privacidad
        </a>
      </p>
    </div>
  );
}